"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rimini": {
    "7ad057bf": [{
      "hkey": "c3d9ee27",
      "slug": "bellariva",
      "name": "Bellariva",
      "primary": true,
      "skipSearch": false
    }],
    "bellariva": [{
      "hkey": "c3d9ee27",
      "slug": "bellariva",
      "name": "Bellariva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bellariva-marebello-rivazzurra-miramare"
    }],
    "3087024d": [{
      "hkey": "c13d916e",
      "slug": "borgo-san-giuliano",
      "name": "Borgo San Giuliano",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-san-giuliano": [{
      "hkey": "c13d916e",
      "slug": "borgo-san-giuliano",
      "name": "Borgo San Giuliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro"
    }],
    "97e5520d": [{
      "hkey": "50c816d8",
      "slug": "celle",
      "name": "Celle",
      "primary": true,
      "skipSearch": false
    }],
    "celle": [{
      "hkey": "50c816d8",
      "slug": "celle",
      "name": "Celle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "celle-rivabella-torre-pedrera-viserba"
    }],
    "fb3f318d": [{
      "hkey": "6b8146f3",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "6b8146f3",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro"
    }],
    "aa791978": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "skipSearch": false
    }],
    "centro-studi": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rimini"
    }],
    "6c4426cb": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "skipSearch": false
    }],
    "colonnella": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rimini"
    }],
    "fd2d72cf": [{
      "hkey": "0e90b208",
      "slug": "rimini",
      "name": "Rimini",
      "primary": true,
      "skipSearch": false
    }],
    "dogana": [{
      "hkey": "0e90b208",
      "slug": "rimini",
      "name": "Rimini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25044298": [{
      "hkey": "2d1ac356",
      "slug": "fiera-vecchia-via-covignano-villaggio-azzurro",
      "name": "Fiera Vecchia-Via Covignano-Villaggio Azzurro",
      "primary": true,
      "skipSearch": false
    }],
    "fiera-vecchia": [{
      "hkey": "2d1ac356",
      "slug": "fiera-vecchia-via-covignano-villaggio-azzurro",
      "name": "Fiera Vecchia-Via Covignano-Villaggio Azzurro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "borgo-mazzini"
    }],
    "cc0faef3": [{
      "hkey": "54ae100f",
      "slug": "grotta-rossa",
      "name": "Grotta Rossa",
      "primary": true,
      "skipSearch": false
    }],
    "grotta-rossa": [{
      "hkey": "54ae100f",
      "slug": "grotta-rossa",
      "name": "Grotta Rossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "colle-di-covignano-grotta-rossa"
    }],
    "fbd76efc": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "skipSearch": false
    }],
    "lagomaggio": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9999ad37": [{
      "hkey": "471142de",
      "slug": "marebello-rivazzurra",
      "name": "Marebello-Rivazzurra",
      "primary": true,
      "skipSearch": false
    }],
    "marebello": [{
      "hkey": "471142de",
      "slug": "marebello-rivazzurra",
      "name": "Marebello-Rivazzurra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bellariva-marebello-rivazzurra-miramare"
    }],
    "54214a6e": [{
      "hkey": "3e693f58",
      "slug": "borgo-mazzini",
      "name": "Borgo Mazzini",
      "primary": true,
      "skipSearch": false
    }],
    "marecchiese": [{
      "hkey": "3e693f58",
      "slug": "borgo-mazzini",
      "name": "Borgo Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "28057cda": [{
      "hkey": "94a9d694",
      "slug": "marina-centro",
      "name": "Marina Centro",
      "primary": true,
      "skipSearch": false
    }],
    "marina-centro": [{
      "hkey": "94a9d694",
      "slug": "marina-centro",
      "name": "Marina Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro"
    }],
    "6cbd52ce": [{
      "hkey": "83042d58",
      "slug": "miramare",
      "name": "Miramare",
      "primary": true,
      "skipSearch": false
    }],
    "miramare": [{
      "hkey": "83042d58",
      "slug": "miramare",
      "name": "Miramare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bellariva-marebello-rivazzurra-miramare"
    }],
    "485ba424": [{
      "hkey": "8b1f0e0e",
      "slug": "viserba-viserbella",
      "name": "Viserba-Viserbella",
      "primary": true,
      "skipSearch": false
    }],
    "nuovo-insediamento-fiera": [{
      "hkey": "8b1f0e0e",
      "slug": "viserba-viserbella",
      "name": "Viserba-Viserbella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "celle-rivabella-torre-pedrera-viserba"
    }],
    "b80c27b4": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "skipSearch": false
    }],
    "pascoli": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rimini"
    }],
    "cce2a992": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "skipSearch": false
    }],
    "praga": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rimini"
    }],
    "2fbc43f0": [{
      "hkey": "0e90b208",
      "slug": "rimini",
      "name": "Rimini",
      "primary": true,
      "skipSearch": false
    }],
    "regioni": [{
      "hkey": "0e90b208",
      "slug": "rimini",
      "name": "Rimini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f1681c9a": [{
      "hkey": "50c816d8",
      "slug": "celle",
      "name": "Celle",
      "primary": true,
      "skipSearch": false
    }],
    "rivabella": [{
      "hkey": "50c816d8",
      "slug": "celle",
      "name": "Celle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "celle-rivabella-torre-pedrera-viserba"
    }],
    "5f7cc869": [{
      "hkey": "471142de",
      "slug": "marebello-rivazzurra",
      "name": "Marebello-Rivazzurra",
      "primary": true,
      "skipSearch": false
    }],
    "rivazzurra": [{
      "hkey": "471142de",
      "slug": "marebello-rivazzurra",
      "name": "Marebello-Rivazzurra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "bellariva-marebello-rivazzurra-miramare"
    }],
    "9c6fe043": [{
      "hkey": "63be63ca",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-giuliano": [{
      "hkey": "63be63ca",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rimini"
    }],
    "ef635257": [{
      "hkey": "69987e6c",
      "slug": "san-giuliano-mare",
      "name": "San Giuliano Mare",
      "primary": true,
      "skipSearch": false
    }],
    "san-giuliano-mare": [{
      "hkey": "69987e6c",
      "slug": "san-giuliano-mare",
      "name": "San Giuliano Mare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro"
    }],
    "f04a5b31": [{
      "hkey": "2c6216d5",
      "slug": "torre-pedrera",
      "name": "Torre Pedrera",
      "primary": true,
      "skipSearch": false
    }],
    "torre-pedrera": [{
      "hkey": "2c6216d5",
      "slug": "torre-pedrera",
      "name": "Torre Pedrera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "celle-rivabella-torre-pedrera-viserba"
    }],
    "1de06f8b": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "skipSearch": false
    }],
    "tripoli": [{
      "hkey": "add528f3",
      "slug": "lagomaggio-ospedale-stadio-tripoli",
      "name": "Lagomaggio-Ospedale-Stadio-Tripoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rimini"
    }],
    "45e7736b": [{
      "hkey": "4f10420b",
      "slug": "gross-le-befane",
      "name": "Gross-Le Befane",
      "primary": true,
      "skipSearch": false
    }],
    "via-coriano": [{
      "hkey": "4f10420b",
      "slug": "gross-le-befane",
      "name": "Gross-Le Befane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "gross-villaggio-primo-maggio"
    }],
    "eb8bfcdc": [{
      "hkey": "2d1ac356",
      "slug": "fiera-vecchia-via-covignano-villaggio-azzurro",
      "name": "Fiera Vecchia-Via Covignano-Villaggio Azzurro",
      "primary": true,
      "skipSearch": false
    }],
    "via-covignano": [{
      "hkey": "2d1ac356",
      "slug": "fiera-vecchia-via-covignano-villaggio-azzurro",
      "name": "Fiera Vecchia-Via Covignano-Villaggio Azzurro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "borgo-mazzini"
    }],
    "0bbc6dfa": [{
      "hkey": "8f52e06d",
      "slug": "villaggio-primo-maggio-via-montescudo",
      "name": "Villaggio Primo Maggio-Via Montescudo",
      "primary": true,
      "skipSearch": false
    }],
    "via-dario-campana": [{
      "hkey": "8f52e06d",
      "slug": "villaggio-primo-maggio-via-montescudo",
      "name": "Villaggio Primo Maggio-Via Montescudo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "gross-villaggio-primo-maggio"
    }],
    "ad90814f": [{
      "hkey": "8f52e06d",
      "slug": "villaggio-primo-maggio-via-montescudo",
      "name": "Villaggio Primo Maggio-Via Montescudo",
      "primary": true,
      "skipSearch": false
    }],
    "via-montescudo": [{
      "hkey": "8f52e06d",
      "slug": "villaggio-primo-maggio-via-montescudo",
      "name": "Villaggio Primo Maggio-Via Montescudo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "gross-villaggio-primo-maggio"
    }],
    "e68db29f": [{
      "hkey": "8b1f0e0e",
      "slug": "viserba-viserbella",
      "name": "Viserba-Viserbella",
      "primary": true,
      "skipSearch": false
    }],
    "viserba": [{
      "hkey": "8b1f0e0e",
      "slug": "viserba-viserbella",
      "name": "Viserba-Viserbella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "celle-rivabella-torre-pedrera-viserba"
    }],
    "b3221429": [{
      "hkey": "8b1f0e0e",
      "slug": "viserba-viserbella",
      "name": "Viserba-Viserbella",
      "primary": true,
      "skipSearch": false
    }],
    "viserbella": [{
      "hkey": "8b1f0e0e",
      "slug": "viserba-viserbella",
      "name": "Viserba-Viserbella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "celle-rivabella-torre-pedrera-viserba"
    }]
  }
};
exports["default"] = _default;